let isHousingRoutePage=false

export const setHousingFormRoutePage=(status)=>{
    isHousingRoutePage=status
}

export  const getHousingFormRoutePage=()=>isHousingRoutePage
